import { gql, useMutation } from '@apollo/client'
import { useNotification } from '@btime/react-messager'

import { cleanRequest } from './cleanRequest'
import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { useCloneForm } from '../_form/CloneServiceOrderForm'
import { useCloseModal } from '../../../../components/modals/ModalsContext'

const MUTATION = gql`
  mutation UpsertServiceOrder($input: ServiceOrderInput) {
    upsertServiceOrder(input: $input) {
      id
    }
  }
`

export const useCloneServiceOrder = () => {
  const form = useCloneForm()
  const notify = useNotification()
  const closeModal = useCloseModal()
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['ServiceOrders'], client: serviceOrdersClient })

  const handleRequest = ({ onSuccess }) => {
    const input = cleanRequest(form)

    return request({ variables: { input } }).then(resp => {
      if (!resp.errors) {
        notify.success({ title: 'Atividade clonada com sucesso' })
        closeModal()
        onSuccess && onSuccess(resp.data.upsertServiceOrder)
      } else {
        notify.error({ title: 'Ocorreu um erro ao clonar a atividade' })
      }
    })
  }

  return [handleRequest, state]
}
